/**
 * Priority Actions — action family names → codes.
 *
 * A PriorityTableCard lists the families its rows use by NAME (card.filters.action_family,
 * e.g. "School Safeguarding & Support") while each row carries the CODES (row_meta[i].families,
 * e.g. ["SS", "TE"]). The System Intervention pages filter rows by family, so they need the
 * name → code map. The names are the datahouse's own (recommend_rules.FAMILIES).
 */
export const FAMILY_CODE_BY_NAME = {
    'PbDQ Learning Program': 'PL',
    'Parental Engagement': 'PE',
    'Teacher Empowerment': 'TE',
    'School Safeguarding & Support': 'SS',
    'Assessment Package': 'AP',
};

export const familyCodeOf = (name) => FAMILY_CODE_BY_NAME[name] || null;

/** code → name, e.g. "SS" → "School Safeguarding & Support". */
export const FAMILY_NAME_BY_CODE = Object.fromEntries(Object.entries(FAMILY_CODE_BY_NAME).map(([name, code]) => [code, name]));

/** The order the dashboards list the families in (the "Standard Action Families" chip row). */
export const FAMILY_DISPLAY_ORDER = ['AP', 'PE', 'SS', 'TE', 'PL'];

/** The family of an action code: its two-letter prefix ("PE2" → "PE"); null when it is not a known family. */
export const familyOfActionCode = (code) => {
    const prefix = String(code || '').slice(0, 2).toUpperCase();
    return FAMILY_NAME_BY_CODE[prefix] ? prefix : null;
};
